
// import { ReactComponent as ClickUp } from "../../../../assets/icons/clickUp-icon.svg";
import { ReactComponent as Dataverse } from "../../../../assets/icons/dataverse-icon.svg";
// import { ReactComponent as Jira } from "../../../../assets/icons/jira-icon.svg";
// import { ReactComponent as Arrow } from "../../../../assets/icons/arrow-icon.svg";
// import { ReactComponent as Monday } from "../../../../assets/icons/monday-icon.svg";
// import { ReactComponent as OneDrive } from "../../../../assets/icons/oneDrive-icon.svg";
// import { ReactComponent as PowerBI } from "../../../../assets/icons/powerBI-icon.svg";
// import { ReactComponent as PPM } from "../../../../assets/icons/ppm-icon.svg";
// import { ReactComponent as Online } from "../../../../assets/icons/projectOnline-icon.svg";
// import { ReactComponent as ServiceNow } from "../../../../assets/icons/serviceNow-icon.svg";
import { ReactComponent as History } from "../../../../assets/icons/history-icon.svg";
import { ReactComponent as Load } from "../../../../assets/icons/load-icon.svg";
import { ReactComponent as Planner } from "../../../../assets/icons/msplanner2024-icon.svg";
// import { ReactComponent as Planner } from "../../../../assets/icons/microsoftPlanner-icon.svg";
import { ReactComponent as Reports } from "../../../../assets/icons/reports-icon.svg";
import { ReactComponent as Settings } from "../../../../assets/icons/settings-icon.svg";
import { ReactComponent as User } from "../../../../assets/icons/user-icon.svg";
import { PATHS } from "../../../../constants/PATHS";
import { MSALBar } from "../../../MSAL/MSALBar";

export const names = {
  [PATHS.BASE_PATH]: { 
    title: "Home", 
    icon: null, 
    addon: null 
  },
  [PATHS.CONNECT_DATA_PATH]: { 
    title: "Connect Data", 
    icon: null, 
    addon: null 
  },
  [PATHS.LOAD_DATA_PATH]: { 
    title: "Load Data", 
    icon: <Load />, 
    addon: null 
  },
  [PATHS.DATAVERSE]: { 
    title: "Dataverse", 
    icon: <Dataverse />, 
    addon: null 
  },
  [PATHS.MSPLANNER]: { 
    title: "Planner", 
    icon: <Planner />, 
    addon: <MSALBar /> 
  },
  [PATHS.REPORTS_PATH]: { 
    title: "Reports", 
    icon: <Reports />, 
    addon: null 
  },
  [PATHS.HISTORY_PATH]: { 
    title: "History", 
    icon: <History />, 
    addon: null 
  },
  [PATHS.ACCOUNT_SETTINGS]: { 
    title: "Account Settings", 
    icon: <Settings />, 
    addon: null 
  },
  [PATHS.PROFILE_SETTINGS]: { 
    title: "Profile Settings", 
    icon: <User />, 
    addon: null 
  },
  [PATHS.REPORTS.PROJECT]: { 
    title: "Project Summary", 
    icon: <Reports />, 
    addon: null 
  },
  [PATHS.REPORTS.MILESTONES]: { 
    title: "Milestone Summary", 
    icon: <Reports />, 
    addon: null 
  },
  [PATHS.REPORTS.ISSUES]: { 
    title: "Issue Summary", 
    icon: <Reports />, 
    addon: null 
  },
  [PATHS.PRIVACY_POLICY_PATH]: { 
    title: "Privacy Policy", 
    icon: <Settings />, 
    addon: null 
  },
  [PATHS.SETTINGS]: { 
    title: "Settings", 
    icon: <Settings />, 
    addon: null 
  }
}